import { render } from "./all_notification.vue?vue&type=template&id=06253610"
import script from "./all_notification.vue?vue&type=script&lang=js"
export * from "./all_notification.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__